/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicUnsubscribeRequest } from "../models/PublicUnsubscribeRequest";
import type { PublicUnsubscribeUpdate } from "../models/PublicUnsubscribeUpdate";
import type { PublicUnsubscribeView } from "../models/PublicUnsubscribeView";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class PublicUnsubscribesService {
  /**
   * Load Unsubscribe
   * Whose promotional emails the link is for, and whether it is unsubscribed.
   * @returns PublicUnsubscribeView Successful Response
   * @throws ApiError
   */
  public static loadUnsubscribe({
    requestBody,
  }: {
    requestBody: PublicUnsubscribeRequest;
  }): CancelablePromise<PublicUnsubscribeView> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/public/unsubscribe/load",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Unsubscribe
   * Unsubscribe the link's address from the organization's promotional
   * emails, or subscribe it again. Operational messages never stop.
   * @returns PublicUnsubscribeView Successful Response
   * @throws ApiError
   */
  public static updateUnsubscribe({
    requestBody,
  }: {
    requestBody: PublicUnsubscribeUpdate;
  }): CancelablePromise<PublicUnsubscribeView> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/public/unsubscribe",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
